<template>
    <div class="takeaway">
        <div class="store-wrapper">
        <div class="container">
            <div class="discussion-guide">
                <div class="header">
                    <h1>Discussion Guide</h1>
                </div>
                <h1>ORC</h1>
                <p>The ORC department is responsible for investigating organized retail crime to prevent future shrink from fence operations.</p>

                <h1>Reporting</h1>
                <p>AP Investigations relies on intel from the store level to identify and investigate ORC operations.</p>

                <h1>Booster Interviews</h1>
                <p>When interviewing a potential suspect, it’s vital to get to the point efficiently and avoid common mistakes that could derail the investigation and distract from the bigger picture.</p>
                <p><a href="./trivia_answers.pdf" target="_blank">REVIEW TRIVIA</a></p>
            </div>
            <div class="leaderboard">
                <table>
                    <thead>
                        <tr>
                            <th>RANK</th>
                            <th>PLAYER</th>
                            <th>SCORE</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(player, index) in this.players" :key="index">
                            <td>{{ index + 1 }}</td>
                            <td>{{ player.name }}</td>
                            <td>{{ player.score }}</td>
                        </tr>
                    </tbody>
                    </table>
            </div>
        </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'takeaway',
    data() {
        return {
            players: [],
            polling: null
        }
    },
    methods: {
        pollData () {
            const api = 'https://6emcgv6qw5.execute-api.us-east-1.amazonaws.com/dev/'
            this.$http.get(api).then((response) => {
                return this.players = response.data
            })
            
            this.polling = setInterval(() => {
                this.$http.get(api).then((response) => {
                    return this.players = response.data
                })
            }, 15000)
        }
    },
    beforeDestroy () {
        clearInterval(this.polling)
    },
    created () {
        this.pollData()
    },
    mounted() {
        window.setTimeout(() => {
          window.scrollTo(0,1)
        }, 1000)
    }
}
</script>

<style lang="scss" scoped>
    .takeaway {
       background: rgb(250,119,7);
       background: linear-gradient(0deg, rgba(250,119,7,1) 0%, rgba(239,190,83,1) 100%);
       height: 100%;
       margin: 0;
       padding: 0;
       text-align: left;
    }

    .store-wrapper {
        background: url('~@/assets/takeaway-bg.png') top center no-repeat;
        background-size: contain;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    .container {
        margin: 0 auto;
        max-width: 1024px;
        margin-top:100px;
    }

    .discussion-guide {
        float: left;
        background-color: #fff;
        width: 55%;
        margin-top:200px;
        -webkit-box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.65);
        -moz-box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.65);
        box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.65);
    }
    .header h1 {
        background: rgb(250,119,7);
        background: linear-gradient(270deg, rgba(250,119,7,1) 0%, rgba(244,155,34,1) 100%);
        font-size: 42px;
        padding: 20px 30px;
        color: #fff;
        margin-bottom: 30px;
    }
    h1 {
        margin-bottom:0;
        padding:0 30px;
        font-size: 21px;
        font-weight: bold;
    }
    p {
        color: #000;
        padding:0 30px;
        margin-top:0;
    }
    .leaderboard {
        background: url('~@/assets/leaderboard.svg') top center no-repeat;
        background-size: cover;
        float:left;
        width: 45%;
        height: 810px;
    }

    a {
        display: inline-block;
        padding: 15px 55px 15px 20px;
        background: url('~@/assets/arrow.png') no-repeat scroll 130px 15px rgb(250,119,7),;
        background-size: 1.5em;
        color: #fff;
        text-decoration: none;
        border-radius: 30px;
        font-weight: bold;
        margin: 10px 0 20px 0;
    }

    table {
        margin: 55px 0 0 45px;
        width: 80%;
        border-collapse: collapse;
        border-spacing: 0;
    }

    thead {
        font-size: 24px;
    }

    tbody {
        font-weight: bold;
        font-size: 22px;
        color: #000;
        line-height: 24px;
    }

    th {
        height: 75px;
        padding: 0 10px;
    }

    tbody > tr {
        border: solid 5px #E1E1E1;
    }

    td {
        height: 50px;
        padding: 0 20px;
        text-align: left;
        background-color: #fff;
    }
</style>
